import { Directive, HostListener } from '@angular/core'

@Directive({
  selector: '[ao-stop-click-propagation]',
})
export class StopClickPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation()
  }

  @HostListener('mousedown', ['$event'])
  public onMousedown(event: Event): void {
    event.stopPropagation()
  }
}
